import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b30846ec"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "uf-shop-checkup" }
const _hoisted_2 = { class: "title" }
const _hoisted_3 = { class: "title-div" }
const _hoisted_4 = { class: "title-content" }
const _hoisted_5 = { class: "title-status" }
const _hoisted_6 = { class: "text" }
const _hoisted_7 = { class: "title-time" }
const _hoisted_8 = { class: "title-time" }
const _hoisted_9 = {
  key: 0,
  class: "title-tab"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tab-line" }, null, -1))
const _hoisted_11 = { class: "checkup-content" }
const _hoisted_12 = ["onClick"]
const _hoisted_13 = { class: "item" }
const _hoisted_14 = { class: "item-status" }
const _hoisted_15 = { class: "text" }
const _hoisted_16 = { class: "item-time" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "time-word" }, "时间：", -1))
const _hoisted_18 = ["onClick"]
const _hoisted_19 = { class: "item" }
const _hoisted_20 = { class: "item-status" }
const _hoisted_21 = { class: "text" }
const _hoisted_22 = { class: "item-time" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "time-word" }, "时间：", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_image = _resolveComponent("van-image")!
  const _component_van_tab = _resolveComponent("van-tab")!
  const _component_van_tabs = _resolveComponent("van-tabs")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_van_image, {
          round: "",
          width: "60",
          height: "60",
          src: _ctx.storeInfo.data.logo_url
        }, null, 8, ["src"]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.storeInfo.data.stores_name), 1),
            _createElementVNode("div", {
              class: _normalizeClass(["status-tag", _ctx.stateClass[_ctx.storeInfo.data.state]])
            }, _toDisplayString(_ctx.storeInfo.data.state_name), 3)
          ]),
          _createElementVNode("div", _hoisted_7, "开店检查时间：" + _toDisplayString(_ctx.storeInfo.data.open_time), 1),
          _createElementVNode("div", _hoisted_8, "闭店检查时间：" + _toDisplayString(_ctx.storeInfo.data.close_time), 1),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.storeInfo.data.msg_arr, (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "title-time",
              key: index
            }, _toDisplayString(item), 1))
          }), 128))
        ])
      ])
    ]),
    (_ctx.storeInfo.data.opt_lists)
      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
          (_ctx.storeInfo.data.opt_lists[0])
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "title-tab-text",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.optClick(_ctx.storeInfo.data.opt_lists[0].type)))
              }, _toDisplayString(_ctx.storeInfo.data.opt_lists[0].name), 1))
            : _createCommentVNode("", true),
          _hoisted_10,
          (_ctx.storeInfo.data.opt_lists[1])
            ? (_openBlock(), _createElementBlock("div", {
                key: 1,
                class: "title-tab-text",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.optClick(_ctx.storeInfo.data.opt_lists[1].type)))
              }, _toDisplayString(_ctx.storeInfo.data.opt_lists[1].name), 1))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_11, [
      _createVNode(_component_van_tabs, {
        shrink: "",
        active: _ctx.active,
        "onUpdate:active": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.active) = $event)),
        color: "#3d6eeb",
        "title-active-color": "#3d6eeb"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_van_tab, { title: "开闭店记录" }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.storeInfo.ocList, (item) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "content-items",
                  key: item.id,
                  onClick: ($event: any) => (_ctx.toOCdetail(item))
                }, [
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("div", _hoisted_14, [
                      _createElementVNode("div", _hoisted_15, _toDisplayString(item.oc_type_name), 1),
                      _createElementVNode("div", {
                        class: _normalizeClass(["item-tag", _ctx.tagClass[item.state]])
                      }, _toDisplayString(item.state_name), 3)
                    ]),
                    _createElementVNode("div", _hoisted_16, [
                      _hoisted_17,
                      _createTextVNode(_toDisplayString(item.create_time_name), 1)
                    ])
                  ])
                ], 8, _hoisted_12))
              }), 128))
            ]),
            _: 1
          }),
          _createVNode(_component_van_tab, { title: "延期申请记录" }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.storeInfo.delayLists, (item) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "content-items",
                  key: item.id,
                  onClick: ($event: any) => (_ctx.toDelayDetail(item))
                }, [
                  _createElementVNode("div", _hoisted_19, [
                    _createElementVNode("div", _hoisted_20, [
                      _createElementVNode("div", _hoisted_21, _toDisplayString(item.oc_type_name), 1),
                      _createElementVNode("div", {
                        class: _normalizeClass(["item-tag", _ctx.tagClass[item.state]])
                      }, _toDisplayString(item.state_name), 3)
                    ]),
                    _createElementVNode("div", _hoisted_22, [
                      _hoisted_23,
                      _createTextVNode(_toDisplayString(item.create_time_name), 1)
                    ])
                  ])
                ], 8, _hoisted_18))
              }), 128))
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["active"])
    ])
  ]))
}